export default "__VITE_ASSET__CGiaNMCq__"